import { lazy } from 'react'
import { Routes, Route } from 'react-router'
import { PrivateRoute } from 'website'

const Whatsapp = lazy(() => import(/* webpackChunkName: "Whatsapp" */ '../Whatsapp'))
const CreateTemplate = lazy(() => import(/* webpackChunkName: "Whatsapp" */ '../Whatsapp/CreateTemplate'))
const TemplateReviews = lazy(() => import(/* webpackChunkName: "Whatsapp" */ '../Whatsapp/TemplateReviews'))
const WhatsappConfiguration = lazy(
	() => import(/* webpackChunkName: "Whatsapp" */ '../Whatsapp/SendWhatsapp/views/WhatsappConfiguration'),
)
const SendWhatsapp = lazy(() => import(/* webpackChunkName: "SendWhatsapp" */ '../Whatsapp/SendWhatsapp'))
const WhatsappTransactionDetails = lazy(
	() => import(/* webpackChunkName: "Whatsapp-details-page" */ '../Whatsapp/TransactionDetails'),
)

const WhatsappRoutes = (props: Record<string, any>) => {
	const p = props as any
	return (
		<Routes>
			<Route
				path='scheduled/:id'
				element={
					<PrivateRoute>
						<WhatsappTransactionDetails {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path='template-reviews'
				element={
					<PrivateRoute>
						<TemplateReviews {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path='templates/create/:type'
				element={
					<PrivateRoute>
						<CreateTemplate {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path='templates/create'
				element={
					<PrivateRoute>
						<CreateTemplate {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path='send'
				element={
					<PrivateRoute>
						<SendWhatsapp {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path='settings/:phone_number_id'
				element={
					<PrivateRoute>
						<WhatsappConfiguration {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path='settings'
				element={
					<PrivateRoute>
						<WhatsappConfiguration {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path=':section/:id'
				element={
					<PrivateRoute>
						<WhatsappTransactionDetails {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				path=':section'
				element={
					<PrivateRoute>
						<Whatsapp {...p} />
					</PrivateRoute>
				}
			/>
			<Route
				index
				element={
					<PrivateRoute>
						<SendWhatsapp {...p} />
					</PrivateRoute>
				}
			/>
		</Routes>
	)
}

export default WhatsappRoutes
